<template>
  <div>
    <gmap-map :center="center" :zoom="13" style="width:100%; height: 300px;">
      <gmap-marker :position="siege" @click="toggleInfoWindow()" />
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" 
        :opened="infoWinOpen" @closeclick="infoWinOpen=false">
          <p style="font-size: 14px"><b>MC Consultant</b></p>
      </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>
import Vue from "vue";
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCufmfw6Q-DPn3Dg-aoLIusFSrPDkf2gso"
  }
});

export default {
  name: "GoogleMap",
  data() {
    return {
      center: { lat: 48.637637, lng: 4.947447 },
      siege: { lat: 48.6451241, lng: 4.9623406 },
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    }
  },
  methods: {
    toggleInfoWindow () {
      this.center = this.siege
      this.infoWindowPos = this.siege
      this.infoWinOpen = true
    }
  }
}
</script>
<style>
.vue-map .gm-style-mtc > * {
  font-size: 12px !important;
  height: 32px !important;
}
.vue-map .gm-svpc {
  background-color: transparent !important
}
.vue-map .gmnoprint button img {
  width: 12px !important;
  height: 12px !important;
}
</style>
